const TYPE_LABELS = {
  login_failure: '반복 로그인 실패',
  bulk_change: '대량 변경·삭제',
  bulk_download: '대량 다운로드·내보내기',
  off_hours: '야간 활동',
}

const STATUS_LABELS = {
  open: '미확인',
  acknowledged: '확인',
  resolved: '종결',
}

const SEVERITY_LABELS = {
  high: '높은 위험',
  warning: '주의',
}

const EVIDENCE_LABELS = {
  audit_log_ids: '감사 로그 ID',
  event_types: '이벤트 유형',
  threshold: '탐지 기준 건수',
  window_minutes: '탐지 구간(분)',
  group_fingerprint: '그룹 지문',
  project_ids: '프로젝트 ID',
}

const EVIDENCE_KEY_ORDER = Object.keys(EVIDENCE_LABELS)

function optionsFromLabels(labels) {
  return Object.entries(labels).map(([value, text]) => ({ value, text }))
}

function labelFor(labels, value) {
  if (value === null || value === undefined || value === '') return '-'
  return labels[value] || String(value)
}

export const SECURITY_ALERT_FILTER_OPTIONS = {
  alertType: optionsFromLabels(TYPE_LABELS),
  status: optionsFromLabels(STATUS_LABELS),
  severity: optionsFromLabels(SEVERITY_LABELS),
}

export function securityAlertTypeLabel(value) {
  return labelFor(TYPE_LABELS, value)
}

export function securityAlertStatusLabel(value) {
  return labelFor(STATUS_LABELS, value)
}

export function securityAlertSeverityLabel(value) {
  return labelFor(SEVERITY_LABELS, value)
}

function localDateBoundary(value, endOfDay = false) {
  if (!value) return null
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!match) return null
  const [, year, month, day] = match
  const date = new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    endOfDay ? 23 : 0,
    endOfDay ? 59 : 0,
    endOfDay ? 59 : 0,
    endOfDay ? 999 : 0,
  )
  if (
    date.getFullYear() !== Number(year) ||
    date.getMonth() !== Number(month) - 1 ||
    date.getDate() !== Number(day)
  ) return null
  return date.toISOString()
}

export function buildSecurityAlertQuery(filters = {}) {
  const query = {
    page: Math.max(1, Number(filters.page) || 1),
    page_size: 30,
  }
  const keys = ['alert_type', 'status', 'severity', 'actor', 'organization_root']
  keys.forEach(key => {
    if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
      query[key] = filters[key]
    }
  })
  const createdAtFrom = localDateBoundary(filters.created_at_from)
  const createdAtTo = localDateBoundary(filters.created_at_to, true)
  if (createdAtFrom) query.created_at_from = createdAtFrom
  if (createdAtTo) query.created_at_to = createdAtTo
  return query
}

function evidenceDisplayValue(value) {
  if (value === null || value === undefined || value === '') return '-'
  if (Array.isArray(value)) return value.length ? value.join(', ') : '-'
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

export function securityAlertEvidenceRows(evidence = {}) {
  if (!evidence || typeof evidence !== 'object' || Array.isArray(evidence)) return []
  const knownKeys = EVIDENCE_KEY_ORDER.filter(key => Object.prototype.hasOwnProperty.call(evidence, key))
  const extraKeys = Object.keys(evidence).filter(key => !EVIDENCE_KEY_ORDER.includes(key))
  return [...knownKeys, ...extraKeys].map(key => ({
    key,
    label: EVIDENCE_LABELS[key] || key,
    value: evidence[key],
    displayValue: evidenceDisplayValue(evidence[key]),
  }))
}

export function isSecurityAlertAdmin(permission) {
  return permission === 'admin' || permission === 'super_admin'
}

export function securityAlertActionNoteError(action, actionNote) {
  if (action === 'resolve' && !String(actionNote || '').trim()) {
    return '종결 사유를 입력해 주세요.'
  }
  return ''
}

export function securityAlertUserLabel(userId) {
  return userId === null || userId === undefined || userId === '' ? '-' : `사용자 #${userId}`
}
